import baseUrl from '../../utils/api';
import axios from 'axios';

export default {
  name: 'courseDistribution',
  inject: ['reload'],
  data() {
    return {
      list: {},
      api: '',
      columns: [
        { prop: 'category', label: '类别', formatter: row => row.category || '--' },
        { prop: 'name', label: '商品名称', formatter: row => row.name || '--' },
        { prop: 'code', label: '商品编号', formatter: row => row.code || '--' },
        { prop: 'course_count', label: '课时总数', formatter: row => (row.course_count || row.course_count == 0) ? row.course_count : '--' },
        { prop: 'offline_price', label: '线下课时原单价（/课时/次）', formatter: row =>  (row.offline_price || row.offline_price == 0) ? row.offline_price : '--' },
        { prop: 'offline_discount_price', label: '线下课时优惠单价（/课时/次）', formatter: row => (row.offline_discount_price || row.offline_discount_price == 0) ? row.offline_discount_price : '--' },
        { prop: 'online_price', label: '线上课时原单价（/课时/学生/次）', formatter: row => (row.online_price || row.online_price == 0) ? row.online_price : '--' },
        { prop: 'online_discount_price', label: '线上课时优惠单价（/课时/学生/次）', formatter: row => (row.online_discount_price || row.online_discount_price == 0) ? row.online_discount_price : '--' },
        { prop: 'created_at', label: '创建时间', formatter: row => row.created_at || '--' },
        { prop: 'publish_time', label: '最近上架时间', formatter: row => row.publish_time || '--' },
        { prop: 'status_text', label: '上下架状态', formatter: row => row.status_text || '--' },
      ],

      formData: {},
      formLoading: false,
      formDialogVisible: false,
      form: {
        title: '新增商品',
        name: '', // 姓名
        cover: '', // 封面
        video: '', // 视频
        introduction: '', // 简介
        detail: '', // 详情
        commodity_tag_id: '', // 商品类别
        offline_price: '', // 线下课时原单价
        offline_discount_price: '', // 线下课时优惠单价
        online_price: '', // 线上课时原单价
        online_discount_price: '', // 线上课时优惠单价
        stage_tag_id: '', // 教育阶段
        subject_tag_id: '', // 学科
        status: '', // 立即 | 手动上架

        school_ids: '', // 开放校区
        make_school_id: '', // 制作校区
      },
      rules: {
        name: [
          { required: true, message: '请输入商品名称' },
        ],
        cover: [
          { required: true, message: '请选择商品封面图' }
        ]
      },

      commodity_tag_list: [], // 商品类型
      stage_tag_list: [], // 教育阶段
      subject_tag_list: [], // 学科
      school_list: [], // 开放校区
      school_list_make: '', // 制作校区

      school_id: this.$store.state.choicesSchool.id,
    }
  },
  created () {
    this.api = `${baseUrl}/api/course/commodities?clients_id=${this.school_id}&equal[make_school_id]=${this.school_id}`;

    this.$http.get(`${baseUrl}/api/tags?order[order]=desc&equal[type]=commodity`).then(res => this.commodity_tag_list = res.items);

    this.$http.get(`${baseUrl}/api/tags?order[order]=desc&equal[type]=stage`).then(res => this.stage_tag_list = res.items);

    this.$http.get(`${baseUrl}/api/tags?order[order]=desc&equal[type]=subject`).then(res => this.subject_tag_list = res.items);
  },
  methods: {
    // 上架
    editShelf (_id, status) {
      this.$http.patch(`/api/course/commodities/${_id}`, {
        status
      }).then(() => {
        this.$message.success(`${status == 2 ? '下架' : '上架'}成功`);
        this.reload();
      })
    },

    // 查看
    editSee (_id) {
      this.formDialogVisible = true;
      this.formLoading = true;

      this.$http.get(`${baseUrl}/api/course/commodities/${_id}`).then(res => {
        res.data.title = '查看详情';
        res.data.see = true;
        this.formData = res.data;

        const _open = [];

        res.data.open_school.forEach(val => {
          val.review_used && _open.push({
            name: val.review_used.name,
            value: val.id
          });
        });
        this.school_list = _open;
        res.data.make_school && (this.school_list_make = res.data.make_school.name);
      }).finally(() => {
        this.formLoading = false;
      });
    },

    // 编辑
    editUpdate (_id) {
      this.$http.get(`/api/course/commodities/${_id}`).then(res => {
        this.formDialogVisible = true;
        res.data.title = '商品编辑'
        res.data.see = true;
        this.formData = res.data;
      });
    },

    // 删除
    editDelete (_id) {
      this.$confirm('确定删除该商品？', '删除确认', {
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '删除',
        confirmButtonClass: 'el-button--danger'
      }).then(() => this.editDeleteConfirm(_id)).catch(() => {});
    },

    editDeleteConfirm (_id) {
      this.$http.delete(`/api/course/commodities/${_id}`).then(() => {
        this.$alert('删除成功', '删除确认', {
          confirmButtonText: '我知道了',
          type: 'success',
          confirmButtonClass: 'success'
        });
        this.reload();
      }).catch(message => {
        this.$alert(message, '删除确认', {
          confirmButtonText: '我知道了',
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        });
      });
    },

    // 课时编辑
    editClass (row) {
      this.$router.push({
        path: '/goods/goodsManageClass',
        query: {
          id: row.id,
          name: row.name,
          introduction: row.introduction,
          category: row.category,
          course_count: row.course_count,
        }
      });
    },

    // 购买统计 | 耗课统计
    editLink(_id, _link) {
      this.$router.push({
        path: `/courseDistribution/${_link}`,
        query: {
          id: _id
        }
      })
    },

    // 上传图片
    getCoverUrl(url) {
      this.$nextTick(() => {
        this.formData.cover = url;
      });
      this.$forceUpdate();
    },

    // 上传视频
    getVideoUrl(url) {
      this.$nextTick(() => {
        this.formData.video = url;
      });
      this.$forceUpdate();
    },

    // 新增
    addCreate() {
      this.formData = this.form;
      this.formDialogVisible = true;
    },

    // 新增 - 确认
    addSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http.post('/api/course/commodities', this.formData).then(() => {
            this.$message.success('保存成功');
            this.formDialogVisible = false;
            this.reload();
          }).catch((err) => {
            this.$message.error(err.message);
          });
        }
      });
    },
    // 商品详情 - 富文本框
    changeFn(data) {
      this.formData.detail = data;
    },
  },
  computed: {
    searchArr() {
      return [
        {
          selectValue: [
            {
              value: 2,
              name: '下架中'
            },
            {
              value: 1,
              name: '上架中'
            },
          ],
          componentType: 'AppSearchStatus',
          searchType: 'status',
          placeholder: ''
        },
        {
          selectValue: this.stage_tag_list ? this.stage_tag_list.map((item) => {
            return { value: item.id, name: item.name }
          }) : [],
          componentType: 'AppSearchStatus',
          searchType: 'stage_tag_id',
          placeholder: ''
        },
        {
          selectValue: this.subject_tag_list ? this.subject_tag_list.map((item) => {
            return { value: item.id, name: item.name }
          }) : [],
          componentType: 'AppSearchStatus',
          searchType: 'subject_tag_id',
          placeholder: ''
        },
        {componentType: 'AppSearchColumn', searchType: [
          { prop: 'name', label: '商品名称' },
          { prop: 'code', label: '编码搜索' },
          { prop: 'search_school_name', label: '校区名称' },
        ]},
      ];
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/CourseDistribution/index.js